import {
  IADatabase,
  IADatabaseCreateCommentDocument,
  IADatabaseSendEmailDocument,
  IDBSearchAndFilters,
} from "../types/admissionDatabase";
import { ITableResponse } from "../types/applicationOnline";
import { toOfficeUrl, toOfficeUrlForApi } from "@/src/utils/accessControl/formatOfficeUrl";
import { apiType } from "./apiType";

export const admissionDatabaseRequests = {
  /** GET /auth?fullname=... — documents for a student from Admissions Office DB. */
  getAuthDocsByFullname: async (fullname: string) => {
    try {
      return await apiType.admissionDB.get<unknown>("/auth", { fullname });
    } catch (error) {
      console.log("Это ошибка getAuthDocsByFullname:", error);
      return null;
    }
  },

  getListAdmin: async (currentPage: string) => {
    try {
      return await apiType.admissionDB.get<ITableResponse>(`/get/all&page=${currentPage}`);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  getListDefault: async (currentPage: string, officeUrl?: string) => {
    try {
      const canonicalOfficeUrl = toOfficeUrl(officeUrl);
      return await apiType.admissionDB.get<IADatabase>("/get/documents", {
        page: currentPage,
        ...(canonicalOfficeUrl ? { office_url: canonicalOfficeUrl } : {}),
      });
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  getListCustom1: async (currentPage: string) => {
    try {
      return await apiType.admissionDB.get<ITableResponse>(
        `/get/certificate-ls&page=${currentPage}`
      );
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  filterAndSearch: async (data: IDBSearchAndFilters & { office_url?: string }) => {
    try {
      const { office_url, ...rest } = data;
      const canonicalOfficeUrl = toOfficeUrl(office_url);
      const payload: IDBSearchAndFilters & { office_url?: string } = { ...rest };
      if (canonicalOfficeUrl) {
        payload.office_url = canonicalOfficeUrl;
      }
      return await apiType.admissionDB.post<IADatabase>(`/filter-and-search`, payload);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  deleteCurrentDocument: async (id: number, userOffice: string) => {
    try {
      return await apiType.admissionDB.delete(`/delete?document_id=${id}&userOffice=${userOffice}`);
    } catch (error) {
      console.log("Это ошибка deleteCurrentDocument:", error);
      return null;
    }
  },
  updateDocument: async (
    documentId: number,
    data: {
      is_avaliable: boolean;
      is_main: boolean;
      form_office: string | null;
      office_url: string | null;
    },
  ) => {
    try {
      const payload = {
        ...data,
        office_url: toOfficeUrlForApi(data.office_url),
      };
      console.log("[AOD] update document request", {
        method: "PUT",
        url: `/documents/${documentId}/`,
        body: payload,
      });
      return await apiType.admissionDB.put(`/documents/${documentId}/`, payload);
    } catch (error) {
      console.log("Это ошибка updateDocument:", error);
      return null;
    }
  },
  /** PUT /documents/current-main/{user_id}/ — set current_main_doc for all docs of this user. */
  updateCurrentMainDocument: async (userId: string | number, currentMainDoc: string) => {
    try {
      const payload = { current_main_doc: currentMainDoc };
      console.log("[AOD] update current main document request", {
        method: "PUT",
        url: `/documents/current-main/${userId}/`,
        body: payload,
      });
      return await apiType.admissionDB.put(`/documents/current-main/${userId}/`, payload);
    } catch (error) {
      console.log("Это ошибка updateCurrentMainDocument:", error);
      return null;
    }
  },
  sendEmailCurrentDocument: async (data: IADatabaseSendEmailDocument) => {
    try {
      // post<IADatabase>
      return await apiType.admissionDB.post(`/send-doc`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  deleteCommentCurrentDocument: async (data: { comment_id: number }) => {
    try {
      return await apiType.admissionDB.delete(`/comments/delete`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  deleteAllCommentsCurrentDocument: async (data: { document_id: number }) => {
    try {
      return await apiType.admissionDB.delete(`/comments/delete-all`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
  createCommentCurrentDocument: async (data: IADatabaseCreateCommentDocument) => {
    try {
      return await apiType.admissionDB.post(`/comments/create`, data);
    } catch (error) {
      console.log("Это ошибка getListAdmin:", error);
      return null;
    }
  },
};
